var map = {
	"./taken_billing.svg": "ccdc",
	"./taken_crm.svg": "3cad",
	"./taken_distribution.svg": "b6ee",
	"./taken_printing.svg": "3ea6",
	"./taken_scanning.svg": "3f26",
	"./taken_shipping.svg": "32d7",
	"./taken_statistics.svg": "bbcc",
	"./taken_stocks.svg": "996e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a354";